// Global audio manager — stops all in-flight audio on route change
const registry = new Set();

export function registerAudio(audio) {
  if (!audio) return audio;
  registry.add(audio);
  const cleanup = () => registry.delete(audio);
  audio.addEventListener('ended', cleanup);
  audio.addEventListener('error', cleanup);
  audio.addEventListener('pause', () => {
    // Keep registered while paused mid-play; remove only if fully stopped
    if (audio.currentTime === 0) registry.delete(audio);
  });
  return audio;
}

export function stopAllAudio() {
  registry.forEach(a => {
    try {
      a.pause();
      a.currentTime = 0;
      a.src = '';
    } catch { /* noop */ }
  });
  registry.clear();
}
